import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  paddingX: "20px",
  paddingY: { xs: "4px", sm: "10px", md: "10px" },
  "@media (orientation: landscape) and (max-width: 960px)": {
    paddingY: "2px",
  },
};

export const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
};

export const nameTypographyStyle: SxProps<Theme> = (theme) => ({
  color: theme.palette.leaderBoardBlock?.textColor,
  fontSize: "14px",
  paddingX: "20px",
});

export const valueTypographyStyle: SxProps<Theme> = (theme) => ({
  color: theme.palette.header.userBlock.linkColor,
  fontSize: "14px",
  paddingX: "20px",
});
